var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import { CloseWithoutBorder } from "../../../assets/images";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
export var InvoicesTypes_E = /*#__PURE__*/ function (InvoicesTypes_E) {
    InvoicesTypes_E["Paid"] = "Paid amount";
    InvoicesTypes_E["Expenses"] = "Expenses amount";
    InvoicesTypes_E["GenerateClaims"] = "Claim amount";
    return InvoicesTypes_E;
}({});
export var InvoicesTypes = {
    1: InvoicesTypes_E.Paid,
    2: InvoicesTypes_E.Expenses,
    3: InvoicesTypes_E.GenerateClaims
};
export var JobCardTotalAmountPopup = function (_ref) {
    var _formValues$partDetai, _formValues$labourDet;
    var formValues = _ref.formValues, onClose = _ref.onClose, totalAmount = _ref.totalAmount;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var selectedParts = (formValues === null || formValues === void 0 || (_formValues$partDetai = formValues.partDetails) === null || _formValues$partDetai === void 0 ? void 0 : _formValues$partDetai.filter(function (item) { return !(item !== null && item !== void 0 && item.IsDeleted); })) || [];
    var selectedLabours = (formValues === null || formValues === void 0 || (_formValues$labourDet = formValues.labourDetails) === null || _formValues$labourDet === void 0 ? void 0 : _formValues$labourDet.filter(function (item) { return !(item !== null && item !== void 0 && item.IsDeleted); })) || [];
    // const selectedParts = formValues?.partDetails?.filter((item: any) => !item?.IsDeleted) || []
    // const selectedLabours = formValues?.labourDetails?.filter((item: any) => !item?.IsDeleted) || []
    var partLabourListGroupByPostingType = __spreadArray(__spreadArray([], selectedParts, true), selectedLabours, true).map(function (item) {
        var _formValues$partDetai2;
        return {
            SavedPriceWithTax: item === null || item === void 0 ? void 0 : item.SavedPriceWithTax,
            PostingTypeValue: item === null || item === void 0 ? void 0 : item.PostingTypeValue,
            PostingTypeName: item === null || item === void 0 ? void 0 : item.PostingTypeName,
            jobType: formValues !== null && formValues !== void 0 && (_formValues$partDetai2 = formValues.partDetails) !== null && _formValues$partDetai2 !== void 0 && _formValues$partDetai2.includes(item) ? "Part" : "Labour",
            id: item === null || item === void 0 ? void 0 : item.id
        };
    });
    var groupedData = partLabourListGroupByPostingType.reduce(function (acc, curr) {
        var key = "".concat(curr.PostingTypeValue, "_").concat(curr.PostingTypeName);
        if (!acc[key]) {
            acc[key] = {
                PostingTypeValue: curr.PostingTypeValue,
                PostingTypeName: curr.PostingTypeName,
                id: curr.id
            };
        }
        if (!acc[key][curr.jobType]) {
            acc[key][curr.jobType] = [];
        }
        acc[key][curr.jobType].push(curr.SavedPriceWithTax);
        return acc;
    }, {});
    var finalGroupedArray = Object.values(groupedData);
    var hostingTypesElements = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            gap: '12px',
            sx: {
                background: '#F4F7FA'
            },
            containerProps: {
                sx: {
                    background: 'yellow'
                }
            },
            elements: [{
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 12,
                    containerProps: {
                        height: 'auto'
                    }
                }, {
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    sx: {
                        border: 'none'
                    },
                    contentProps: {
                        spacing: 0,
                        gap: '12px'
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'parts-total',
                            label: 'Parts total',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'base',
                                color: '#505862'
                            },
                            fontWeight: 'strong',
                            columnSize: 12,
                            color: 'text.primary',
                            setFieldProps: function (formValues, currValue, field) {
                                var _formValues$Part;
                                var partsTotal = (formValues === null || formValues === void 0 || (_formValues$Part = formValues.Part) === null || _formValues$Part === void 0 ? void 0 : _formValues$Part.reduce(function (acc, item) { return acc + item.Amount; }, 0)) || 0;
                                return {
                                    type: FormItemTypes.Typography,
                                    value: "\u20B9 ".concat(partsTotal.toFixed(2))
                                };
                            }
                            // valueGetter(formValues, field) {
                            //     const partsTotal = formValues?.Part?.reduce((acc: number, item: any) => acc + item.Amount, 0) || 0
                            //     return {
                            //         type: FormItemTypes.Typography,
                            //         value: `₹ ${partsTotal.toFixed(2)}`
                            //     }
                            // },
                        }, {
                            type: FormItemTypes.Divider,
                            name: '',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'base-amount',
                            label: 'Base amount',
                            setFieldProps: function (formValues, currValue, field) {
                                var _formValues$Part2;
                                var baseAmountTotal = (formValues === null || formValues === void 0 || (_formValues$Part2 = formValues.Part) === null || _formValues$Part2 === void 0 ? void 0 : _formValues$Part2.reduce(function (acc, item) { return acc + item.BaseAmount; }, 0)) || 0;
                                return {
                                    type: FormItemTypes.Typography,
                                    value: "\u20B9 ".concat(baseAmountTotal.toFixed(2))
                                };
                            },
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        },
                        // {
                        //     type: FormItemTypes.ContainerItem,
                        //     name: '',
                        //     columnSize: 12,
                        //     spacing: 0,
                        //     alignItems: 'center',
                        //     elements: [
                        //         {
                        //             type: FormItemTypes.Typography,
                        //             name: '',
                        //             columnSize: 4,
                        //             children: 'Discount_1',
                        //             fontSize: 'sm',
                        //             color: 'text.secondary',
                        //             fontWeight: 'medium',
                        //         },
                        //         {
                        //             type: FormItemTypes.ContainerItem,
                        //             name: '',
                        //             columnSize: 8,
                        //             spacing: 0,
                        //             elements: [
                        //                 {
                        //                     type: FormItemTypes.NumberInput,
                        //                     name: '',
                        //                     columnSize: 4,
                        //                     sx: {
                        //                         '& .MuiOutlinedInput-root': {
                        //                             borderRadius: '8px 0px 0px 8px',
                        //                         },
                        //                         '& .MuiOutlinedInput-notchedOutline': {
                        //                             borderRight: 'none !important'
                        //                         }
                        //                     }
                        //                 },
                        //                 {
                        //                     type: FormItemTypes.NumberInput,
                        //                     name: '',
                        //                     columnSize: 8,
                        //                     sx: {
                        //                         '& .MuiOutlinedInput-root': {
                        //                             borderRadius: '0px 8px 8px 0px'
                        //                         },
                        //                     },
                        //                     inputProps: {
                        //                         style: {
                        //                             textAlign: 'end',
                        //                         }
                        //                     }
                        //                 }
                        //             ],
                        //         },
                        //     ],
                        // },
                        // {
                        //     type: FormItemTypes.ContainerItem,
                        //     name: '',
                        //     columnSize: 12,
                        //     spacing: 0,
                        //     alignItems: 'center',
                        //     elements: [
                        //         {
                        //             type: FormItemTypes.Typography,
                        //             name: '',
                        //             columnSize: 4,
                        //             children: 'Discount_2',
                        //             fontSize: 'sm',
                        //             color: 'text.secondary',
                        //             fontWeight: 'medium',
                        //         },
                        //         {
                        //             type: FormItemTypes.ContainerItem,
                        //             name: '',
                        //             columnSize: 8,
                        //             spacing: 0,
                        //             elements: [
                        //                 {
                        //                     type: FormItemTypes.NumberInput,
                        //                     name: '',
                        //                     columnSize: 4,
                        //                     sx: {
                        //                         '& .MuiOutlinedInput-root': {
                        //                             borderRadius: '8px 0px 0px 8px',
                        //                         },
                        //                         '& .MuiOutlinedInput-notchedOutline': {
                        //                             borderRight: 'none !important'
                        //                         }
                        //                     }
                        //                 },
                        //                 {
                        //                     type: FormItemTypes.NumberInput,
                        //                     name: '',
                        //                     columnSize: 8,
                        //                     sx: {
                        //                         '& .MuiOutlinedInput-root': {
                        //                             borderRadius: '0px 8px 8px 0px'
                        //                         },
                        //                     },
                        //                     inputProps: {
                        //                         style: {
                        //                             textAlign: 'end',
                        //                         }
                        //                     }
                        //                 }
                        //             ],
                        //         },
                        //     ],
                        // },
                        {
                            type: FormItemTypes.Typography,
                            name: 'charge',
                            label: 'Charge',
                            value: '₹ 0',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'taxable-amount',
                            label: 'Taxable amount',
                            setFieldProps: function (formValues, currValue, field) {
                                var _formValues$Part3;
                                var taxableAmountTotal = (formValues === null || formValues === void 0 || (_formValues$Part3 = formValues.Part) === null || _formValues$Part3 === void 0 ? void 0 : _formValues$Part3.reduce(function (acc, item) { return acc + item.TaxableAmount; }, 0)) || 0;
                                return {
                                    type: FormItemTypes.Typography,
                                    value: "\u20B9 ".concat(taxableAmountTotal.toFixed(2))
                                };
                            },
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'cgst',
                            label: 'CGST',
                            setFieldProps: function (formValues, currValue, field) {
                                var _formValues$Part4;
                                var totalCGST = 0;
                                var TaxComponentName = '';
                                formValues === null || formValues === void 0 || (_formValues$Part4 = formValues.Part) === null || _formValues$Part4 === void 0 || _formValues$Part4.forEach(function (part) {
                                    var _part$Taxes;
                                    part === null || part === void 0 || (_part$Taxes = part.Taxes) === null || _part$Taxes === void 0 || _part$Taxes.forEach(function (tax) {
                                        if ((tax === null || tax === void 0 ? void 0 : tax.TaxComponentName) === "CGST") {
                                            TaxComponentName = "CGST";
                                            totalCGST += tax.TaxComponentAmount;
                                        }
                                    });
                                });
                                return {
                                    type: FormItemTypes.Typography,
                                    value: "\u20B9 ".concat(totalCGST.toFixed(2)),
                                    containerProps: {
                                        display: TaxComponentName === "CGST" ? 'inline-flex' : 'none',
                                        justifyContent: 'space-between'
                                    }
                                };
                            },
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'sgst',
                            label: 'SGST',
                            setFieldProps: function (formValues, currValue, field) {
                                var _formValues$Part5;
                                var totalCGST = 0;
                                var TaxComponentName = '';
                                formValues === null || formValues === void 0 || (_formValues$Part5 = formValues.Part) === null || _formValues$Part5 === void 0 || _formValues$Part5.forEach(function (part) {
                                    var _part$Taxes2;
                                    part === null || part === void 0 || (_part$Taxes2 = part.Taxes) === null || _part$Taxes2 === void 0 || _part$Taxes2.forEach(function (tax) {
                                        if ((tax === null || tax === void 0 ? void 0 : tax.TaxComponentName) === "SGST") {
                                            TaxComponentName = "SGST";
                                            totalCGST += tax.TaxComponentAmount;
                                        }
                                    });
                                });
                                return {
                                    type: FormItemTypes.Typography,
                                    value: "\u20B9 ".concat(totalCGST.toFixed(2)),
                                    containerProps: {
                                        display: TaxComponentName === "SGST" ? 'inline-flex' : 'none',
                                        justifyContent: 'space-between'
                                    }
                                };
                            },
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'igst',
                            label: 'IGST',
                            setFieldProps: function (formValues, currValue, field) {
                                var _formValues$Part6;
                                var totalCGST = 0;
                                var TaxComponentName = '';
                                formValues === null || formValues === void 0 || (_formValues$Part6 = formValues.Part) === null || _formValues$Part6 === void 0 || _formValues$Part6.forEach(function (part) {
                                    var _part$Taxes3;
                                    part === null || part === void 0 || (_part$Taxes3 = part.Taxes) === null || _part$Taxes3 === void 0 || _part$Taxes3.forEach(function (tax) {
                                        if ((tax === null || tax === void 0 ? void 0 : tax.TaxComponentName) === "IGST") {
                                            TaxComponentName = "IGST";
                                            totalCGST += tax.TaxComponentAmount;
                                        }
                                    });
                                });
                                return {
                                    type: FormItemTypes.Typography,
                                    value: "\u20B9 ".concat(totalCGST.toFixed(2)),
                                    containerProps: {
                                        display: TaxComponentName === "IGST" ? 'inline-flex' : 'none',
                                        justifyContent: 'space-between'
                                    }
                                };
                            },
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        }]
                }, {
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    sx: {
                        border: 'none'
                    },
                    contentProps: {
                        spacing: 0,
                        gap: '12px'
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'labour-total',
                            label: 'Labours total',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'base',
                                color: '#505862'
                            },
                            fontWeight: 'strong',
                            columnSize: 12,
                            color: 'text.primary',
                            setFieldProps: function (formValues, currValue, field) {
                                var _formValues$Labour;
                                var laboursTotal = (formValues === null || formValues === void 0 || (_formValues$Labour = formValues.Labour) === null || _formValues$Labour === void 0 ? void 0 : _formValues$Labour.reduce(function (acc, item) { return acc + item.Amount; }, 0)) || 0;
                                return {
                                    type: FormItemTypes.Typography,
                                    value: "\u20B9 ".concat(laboursTotal.toFixed(2))
                                };
                            }
                        }, {
                            type: FormItemTypes.Divider,
                            name: '',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'labour-base-amount',
                            label: 'Base amount',
                            setFieldProps: function (formValues, currValue, field) {
                                var _formValues$Labour2;
                                var baseAmountTotal = (formValues === null || formValues === void 0 || (_formValues$Labour2 = formValues.Labour) === null || _formValues$Labour2 === void 0 ? void 0 : _formValues$Labour2.reduce(function (acc, item) { return acc + item.BaseAmount; }, 0)) || 0;
                                return {
                                    type: FormItemTypes.Typography,
                                    value: "\u20B9 ".concat(baseAmountTotal.toFixed(2))
                                };
                            },
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        },
                        // {
                        //     type: FormItemTypes.ContainerItem,
                        //     name: '',
                        //     columnSize: 12,
                        //     spacing: 0,
                        //     alignItems: 'center',
                        //     elements: [
                        //         {
                        //             type: FormItemTypes.Typography,
                        //             name: '',
                        //             columnSize: 4,
                        //             children: 'Discount_1',
                        //             fontSize: 'sm',
                        //             color: 'text.secondary',
                        //             fontWeight: 'medium',
                        //         },
                        //         {
                        //             type: FormItemTypes.ContainerItem,
                        //             name: '',
                        //             columnSize: 8,
                        //             spacing: 0,
                        //             elements: [
                        //                 {
                        //                     type: FormItemTypes.NumberInput,
                        //                     name: '',
                        //                     columnSize: 4,
                        //                     sx: {
                        //                         '& .MuiOutlinedInput-root': {
                        //                             borderRadius: '8px 0px 0px 8px',
                        //                         },
                        //                         '& .MuiOutlinedInput-notchedOutline': {
                        //                             borderRight: 'none !important'
                        //                         }
                        //                     }
                        //                 },
                        //                 {
                        //                     type: FormItemTypes.NumberInput,
                        //                     name: '',
                        //                     columnSize: 8,
                        //                     sx: {
                        //                         '& .MuiOutlinedInput-root': {
                        //                             borderRadius: '0px 8px 8px 0px'
                        //                         },
                        //                     },
                        //                     inputProps: {
                        //                         style: {
                        //                             textAlign: 'end',
                        //                         }
                        //                     }
                        //                 }
                        //             ],
                        //         },
                        //     ],
                        // },
                        // {
                        //     type: FormItemTypes.ContainerItem,
                        //     name: '',
                        //     columnSize: 12,
                        //     spacing: 0,
                        //     alignItems: 'center',
                        //     elements: [
                        //         {
                        //             type: FormItemTypes.Typography,
                        //             name: '',
                        //             columnSize: 4,
                        //             children: 'Discount_2',
                        //             fontSize: 'sm',
                        //             color: 'text.secondary',
                        //             fontWeight: 'medium',
                        //         },
                        //         {
                        //             type: FormItemTypes.ContainerItem,
                        //             name: '',
                        //             columnSize: 8,
                        //             spacing: 0,
                        //             elements: [
                        //                 {
                        //                     type: FormItemTypes.NumberInput,
                        //                     name: '',
                        //                     columnSize: 4,
                        //                     sx: {
                        //                         '& .MuiOutlinedInput-root': {
                        //                             borderRadius: '8px 0px 0px 8px',
                        //                         },
                        //                         '& .MuiOutlinedInput-notchedOutline': {
                        //                             borderRight: 'none !important'
                        //                         }
                        //                     }
                        //                 },
                        //                 {
                        //                     type: FormItemTypes.NumberInput,
                        //                     name: '',
                        //                     columnSize: 8,
                        //                     sx: {
                        //                         '& .MuiOutlinedInput-root': {
                        //                             borderRadius: '0px 8px 8px 0px'
                        //                         },
                        //                     },
                        //                     inputProps: {
                        //                         style: {
                        //                             textAlign: 'end',
                        //                         }
                        //                     }
                        //                 }
                        //             ],
                        //         },
                        //     ],
                        // },
                        {
                            type: FormItemTypes.Typography,
                            name: 'labour-charge',
                            label: 'Charge',
                            value: '₹ 0',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'labour-taxable-amount',
                            label: 'Taxable amount',
                            setFieldProps: function (formValues, currValue, field) {
                                var _formValues$Labour3;
                                var taxableAmountTotal = (formValues === null || formValues === void 0 || (_formValues$Labour3 = formValues.Labour) === null || _formValues$Labour3 === void 0 ? void 0 : _formValues$Labour3.reduce(function (acc, item) { return acc + item.TaxableAmount; }, 0)) || 0;
                                return {
                                    type: FormItemTypes.Typography,
                                    value: "\u20B9 ".concat(taxableAmountTotal.toFixed(2))
                                };
                            },
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'labour-cgst',
                            label: 'CGST',
                            setFieldProps: function (formValues, currValue, field) {
                                var _formValues$Labour4;
                                var totalCGST = 0;
                                var TaxComponentName = '';
                                formValues === null || formValues === void 0 || (_formValues$Labour4 = formValues.Labour) === null || _formValues$Labour4 === void 0 || _formValues$Labour4.forEach(function (labour) {
                                    var _labour$Taxes;
                                    labour === null || labour === void 0 || (_labour$Taxes = labour.Taxes) === null || _labour$Taxes === void 0 || _labour$Taxes.forEach(function (tax) {
                                        if ((tax === null || tax === void 0 ? void 0 : tax.TaxComponentName) === "CGST") {
                                            TaxComponentName = "CGST";
                                            totalCGST += tax.TaxComponentAmount;
                                        }
                                    });
                                });
                                return {
                                    type: FormItemTypes.Typography,
                                    value: "\u20B9 ".concat(totalCGST.toFixed(2)),
                                    containerProps: {
                                        display: TaxComponentName === "CGST" ? 'inline-flex' : 'none',
                                        justifyContent: 'space-between'
                                    }
                                };
                            },
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'labour-sgst',
                            label: 'SGST',
                            setFieldProps: function (formValues, currValue, field) {
                                var _formValues$Labour5;
                                var totalCGST = 0;
                                var TaxComponentName = '';
                                formValues === null || formValues === void 0 || (_formValues$Labour5 = formValues.Labour) === null || _formValues$Labour5 === void 0 || _formValues$Labour5.forEach(function (labour) {
                                    var _labour$Taxes2;
                                    labour === null || labour === void 0 || (_labour$Taxes2 = labour.Taxes) === null || _labour$Taxes2 === void 0 || _labour$Taxes2.forEach(function (tax) {
                                        if ((tax === null || tax === void 0 ? void 0 : tax.TaxComponentName) === "SGST") {
                                            TaxComponentName = "SGST";
                                            totalCGST += tax.TaxComponentAmount;
                                        }
                                    });
                                });
                                return {
                                    type: FormItemTypes.Typography,
                                    value: "\u20B9 ".concat(totalCGST.toFixed(2)),
                                    containerProps: {
                                        display: TaxComponentName === "SGST" ? 'inline-flex' : 'none',
                                        justifyContent: 'space-between'
                                    }
                                };
                            },
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'labour-igst',
                            label: 'IGST',
                            setFieldProps: function (formValues, currValue, field) {
                                var _formValues$Labour6;
                                var totalCGST = 0;
                                var TaxComponentName = '';
                                formValues === null || formValues === void 0 || (_formValues$Labour6 = formValues.Labour) === null || _formValues$Labour6 === void 0 || _formValues$Labour6.forEach(function (labour) {
                                    var _labour$Taxes3;
                                    labour === null || labour === void 0 || (_labour$Taxes3 = labour.Taxes) === null || _labour$Taxes3 === void 0 || _labour$Taxes3.forEach(function (tax) {
                                        if ((tax === null || tax === void 0 ? void 0 : tax.TaxComponentName) === "IGST") {
                                            TaxComponentName = "IGST";
                                            totalCGST += tax.TaxComponentAmount;
                                        }
                                    });
                                });
                                return {
                                    type: FormItemTypes.Typography,
                                    value: "\u20B9 ".concat(totalCGST.toFixed(2)),
                                    containerProps: {
                                        display: TaxComponentName === "IGST" ? 'inline-flex' : 'none',
                                        justifyContent: 'space-between'
                                    }
                                };
                            },
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        }]
                }
                // {
                //     type: FormItemTypes.CardComponent,
                //     name: '',
                //     columnSize: 12,
                //     sx: {
                //         border: 'none'
                //     },
                //     contentProps: {
                //         spacing: 0,
                //         gap: '12px'
                //     },
                //     elements: [
                //         {
                //             type: FormItemTypes.Typography,
                //             name: '',
                //             label: 'Labours total',
                //             value: '₹ 2600.00',
                //             containerProps: { display: 'inline-flex', justifyContent: 'space-between' },
                //             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'base', color: '#505862' },
                //             fontWeight: 'strong',
                //             columnSize: 12,
                //             color: 'text.primary'
                //         },
                //         {
                //             type: FormItemTypes.Divider,
                //             name: '',
                //             columnSize: 12,
                //         },
                //         {
                //             type: FormItemTypes.Typography,
                //             name: '',
                //             label: 'Basic amount',
                //             value: '₹ 5,600.00',
                //             containerProps: { display: 'inline-flex', justifyContent: 'space-between' },
                //             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm', color: 'text.secondary' },
                //             fontWeight: 'medium',
                //             columnSize: 12,
                //             color: 'text.primary'
                //         },
                //         {
                //             type: FormItemTypes.ContainerItem,
                //             name: '',
                //             columnSize: 12,
                //             spacing: 0,
                //             alignItems: 'center',
                //             elements: [
                //                 {
                //                     type: FormItemTypes.Typography,
                //                     name: '',
                //                     columnSize: 4,
                //                     children: 'Discount_1',
                //                     fontSize: 'sm',
                //                     color: 'text.secondary',
                //                     fontWeight: 'medium',
                //                 },
                //                 {
                //                     type: FormItemTypes.ContainerItem,
                //                     name: '',
                //                     columnSize: 8,
                //                     spacing: 0,
                //                     elements: [
                //                         {
                //                             type: FormItemTypes.NumberInput,
                //                             name: '',
                //                             columnSize: 4,
                //                             sx: {
                //                                 '& .MuiOutlinedInput-root': {
                //                                     borderRadius: '8px 0px 0px 8px',
                //                                 },
                //                                 '& .MuiOutlinedInput-notchedOutline': {
                //                                     borderRight: 'none !important'
                //                                 }
                //                             }
                //                         },
                //                         {
                //                             type: FormItemTypes.NumberInput,
                //                             name: '',
                //                             columnSize: 8,
                //                             sx: {
                //                                 '& .MuiOutlinedInput-root': {
                //                                     borderRadius: '0px 8px 8px 0px'
                //                                 },
                //                             },
                //                             inputProps: {
                //                                 style: {
                //                                     textAlign: 'end',
                //                                 }
                //                             }
                //                         }
                //                     ],
                //                 },
                //             ],
                //         },
                //         {
                //             type: FormItemTypes.ContainerItem,
                //             name: '',
                //             columnSize: 12,
                //             spacing: 0,
                //             alignItems: 'center',
                //             elements: [
                //                 {
                //                     type: FormItemTypes.Typography,
                //                     name: '',
                //                     columnSize: 4,
                //                     children: 'Discount_2',
                //                     fontSize: 'sm',
                //                     color: 'text.secondary',
                //                     fontWeight: 'medium',
                //                 },
                //                 {
                //                     type: FormItemTypes.ContainerItem,
                //                     name: '',
                //                     columnSize: 8,
                //                     spacing: 0,
                //                     elements: [
                //                         {
                //                             type: FormItemTypes.NumberInput,
                //                             name: '',
                //                             columnSize: 4,
                //                             sx: {
                //                                 '& .MuiOutlinedInput-root': {
                //                                     borderRadius: '8px 0px 0px 8px',
                //                                 },
                //                                 '& .MuiOutlinedInput-notchedOutline': {
                //                                     borderRight: 'none !important'
                //                                 }
                //                             }
                //                         },
                //                         {
                //                             type: FormItemTypes.NumberInput,
                //                             name: '',
                //                             columnSize: 8,
                //                             sx: {
                //                                 '& .MuiOutlinedInput-root': {
                //                                     borderRadius: '0px 8px 8px 0px'
                //                                 },
                //                             },
                //                             inputProps: {
                //                                 style: {
                //                                     textAlign: 'end',
                //                                 }
                //                             }
                //                         }
                //                     ],
                //                 },
                //             ],
                //         },
                //         {
                //             type: FormItemTypes.Typography,
                //             name: '',
                //             label: 'Charge',
                //             value: '₹ 600.00',
                //             containerProps: { display: 'inline-flex', justifyContent: 'space-between' },
                //             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm', color: 'text.secondary' },
                //             fontWeight: 'medium',
                //             columnSize: 12,
                //             color: 'text.primary'
                //         },
                //         {
                //             type: FormItemTypes.Typography,
                //             name: '',
                //             label: 'Taxable amount',
                //             value: '₹ 5,600.00',
                //             containerProps: { display: 'inline-flex', justifyContent: 'space-between' },
                //             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm', color: 'text.secondary' },
                //             fontWeight: 'medium',
                //             columnSize: 12,
                //             color: 'text.primary'
                //         },
                //         {
                //             type: FormItemTypes.Typography,
                //             name: '',
                //             label: 'CGST',
                //             value: '₹ 5,600.00',
                //             containerProps: { display: 'inline-flex', justifyContent: 'space-between' },
                //             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm', color: 'text.secondary' },
                //             fontWeight: 'medium',
                //             columnSize: 12,
                //             color: 'text.primary'
                //         },
                //         {
                //             type: FormItemTypes.Typography,
                //             name: '',
                //             label: 'IGST',
                //             value: '₹ 5,600.00',
                //             containerProps: { display: 'inline-flex', justifyContent: 'space-between' },
                //             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm', color: 'text.secondary' },
                //             fontWeight: 'medium',
                //             columnSize: 12,
                //             color: 'text.primary'
                //         },
                //         {
                //             type: FormItemTypes.Typography,
                //             name: '',
                //             label: 'SGST',
                //             value: '₹ 5,600.00',
                //             containerProps: { display: 'inline-flex', justifyContent: 'space-between' },
                //             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm', color: 'text.secondary' },
                //             fontWeight: 'medium',
                //             columnSize: 12,
                //             color: 'text.primary'
                //         },
                //     ],
                // },
            ]
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            columnSize: 12,
            name: 'header',
            padding: "20px 16px 16px 16px",
            spacing: 0,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'headername',
                    children: 'Invoice summary',
                    fontSize: 'xl',
                    fontWeight: 'strong',
                    columnSize: true
                }, {
                    type: FormItemTypes.IconButton,
                    label: '',
                    name: 'cross-icon',
                    value: null,
                    columnSize: 1,
                    children: /*#__PURE__*/ React.createElement("img", {
                        src: CloseWithoutBorder
                    }),
                    onClick: function () {
                        onClose();
                    }
                }]
        }, {
            type: FormItemTypes.List,
            name: 'PartsLabours',
            columnSize: 12,
            variant: 'comfortable',
            disableBorder: true,
            disableCheckboxSelection: true,
            cellStyles: {
                border: 'none'
            },
            columns: [{
                    field: 'PartLabour',
                    flex: 1,
                    renderCell: function (_ref2) {
                        var _totalAmount$paidAmou, _totalAmount$expenses, _totalAmount$claimAmo;
                        var row = _ref2.row;
                        return /*#__PURE__*/ React.createElement(Box, {
                            sx: {
                                display: 'flex',
                                justifyContent: 'space-between'
                            }
                        }, /*#__PURE__*/ React.createElement(Typography, {
                            id: InvoicesTypes[row.PostingTypeValue],
                            variant: "h3"
                        }, InvoicesTypes[row.PostingTypeValue]), /*#__PURE__*/ React.createElement(Typography, {
                            variant: "h3",
                            sx: {
                                mr: -0.5
                            }
                        }, InvoicesTypes[row.PostingTypeValue] === InvoicesTypes_E.Paid ? "\u20B9 ".concat((totalAmount === null || totalAmount === void 0 || (_totalAmount$paidAmou = totalAmount.paidAmount) === null || _totalAmount$paidAmou === void 0 ? void 0 : _totalAmount$paidAmou.toFixed(2)) || '0.00') : InvoicesTypes[row.PostingTypeValue] === InvoicesTypes_E.Expenses ? "\u20B9 ".concat((totalAmount === null || totalAmount === void 0 || (_totalAmount$expenses = totalAmount.expensesAmount) === null || _totalAmount$expenses === void 0 ? void 0 : _totalAmount$expenses.toFixed(2)) || '0.00') : InvoicesTypes[row.PostingTypeValue] === InvoicesTypes_E.GenerateClaims ? "\u20B9 ".concat((totalAmount === null || totalAmount === void 0 || (_totalAmount$claimAmo = totalAmount.claimAmount) === null || _totalAmount$claimAmo === void 0 ? void 0 : _totalAmount$claimAmo.toFixed(2)) || '0.00') : "\u20B9 0.00"));
                    }
                }],
            value: null,
            sx: {
                background: '#F4F7FA',
                border: 'none'
            },
            elements: hostingTypesElements
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12
        }, {
            type: FormItemTypes.Typography,
            name: 'total-amount',
            label: 'Total amount',
            containerProps: {
                display: 'inline-flex',
                justifyContent: 'space-between'
            },
            labelTypographyProps: {
                mb: 0,
                noWrap: true,
                fontWeight: 'strong',
                color: 'text.primary'
            },
            fontWeight: 'strong',
            columnSize: 12,
            color: 'text.primary',
            valueGetter: function () {
                return "\u20B9 ".concat(((totalAmount === null || totalAmount === void 0 ? void 0 : totalAmount.paidAmount) + (totalAmount === null || totalAmount === void 0 ? void 0 : totalAmount.expensesAmount) + (totalAmount === null || totalAmount === void 0 ? void 0 : totalAmount.claimAmount)).toFixed(2));
            }
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12
        }, {
            type: FormItemTypes.Typography,
            name: 'net-amount',
            label: 'Net payable amount',
            containerProps: {
                display: 'inline-flex',
                justifyContent: 'space-between'
            },
            labelTypographyProps: {
                mb: 0,
                noWrap: true,
                fontWeight: 'strong',
                color: 'text.primary'
            },
            fontWeight: 'strong',
            columnSize: 12,
            color: 'text.primary',
            valueGetter: function () {
                var _totalAmount$paidAmou2;
                return "\u20B9 ".concat(totalAmount === null || totalAmount === void 0 || (_totalAmount$paidAmou2 = totalAmount.paidAmount) === null || _totalAmount$paidAmou2 === void 0 ? void 0 : _totalAmount$paidAmou2.toFixed(2));
            }
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            width: {
                xs: '100%',
                sm: '360px',
                md: '360px'
            }
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            paddingInline: '12px',
            paddingBottom: '12px',
            gap: '12px'
        },
        gridSpacing: 0,
        mode: "edit",
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ({
                        data: {
                            PartsLabours: finalGroupedArray
                        },
                        success: true
                    })];
            });
        }); }
    })));
};
